import { Table, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr } from '@chakra-ui/react';
import React from 'react';
import { ChargeItens } from 'types/Charge';
import { maskCurrency } from 'utils/number';
import { itensTotal } from './chargeSummary';

const ListItens: React.FC<{
  itens: ChargeItens[];
}> = ({ itens }) => {
  if (!itens?.length) return null;

  return (
    <TableContainer>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Nome</Th>
            <Th isNumeric>Preço unitário</Th>
            <Th isNumeric>Quantidade</Th>
            <Th isNumeric>Valor</Th>
            <Th isNumeric>Taxa</Th>
          </Tr>
        </Thead>
        <Tbody>
          {itens.map((item) => (
            <Tr key={item.id}>
              <Td>{item.name}</Td>
              <Td isNumeric>{maskCurrency(item.unitPrice)}</Td>
              <Td isNumeric>{item.quantity}</Td>
              <Td isNumeric>{maskCurrency(item.amount)}</Td>
              <Td isNumeric>{item.feePercent ?? 0}%</Td>
            </Tr>
          ))}
        </Tbody>
        {/* Uma lista de itens sem soma obriga quem lê a conferir de cabeça se ela bate com
            o valor da cobrança — que é a única pergunta que se faz olhando para ela. */}
        <Tfoot>
          <Tr>
            <Th>Total</Th>
            <Th />
            <Th />
            <Th isNumeric fontSize="sm">
              {maskCurrency(itensTotal(itens))}
            </Th>
            <Th />
          </Tr>
        </Tfoot>
      </Table>
    </TableContainer>
  );
};

export default ListItens;
